import React, { useEffect, useState, useRef } from 'react'
import Menu from '../main/Menu'
import {
    getProcessButtons, getError, isUndNullEmpNew, isUndNullNew, sendMessageCloseCurrentWindow, settings, getResponse, LoadingSection,
    getLanguageObj, awaitDelay, getDtRowIndexNew, setBadgeStatusGenericNew, setDateTimeFormatGlobal
} from '../../helpers/UtilsHelper'
import useAuth from '../../auth/useAuth';
import Swal from 'sweetalert2';
import LargeLanguageModelAddEditDetails from './LargeLanguageModelAddEditDetails';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';
import { LargeLanguageModelService } from '../../services/largeLanguageModel/LargeLanguageModelService';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';

const { app, colors, firebase, html, icons, images, labels, messages, react, timers, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const $ = window?.$;

const currentMethod = 'LanguageLargeModel - function';

export default function LargeLanguageModel({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const isMount = useRef(true);
    const [process, setProcess] = useState({ showLoading: false, add: false });

    const dtLargeLanguageModelsId = 'dtLargeLanguageModels';
    const [largeLanguageModel, setLargeLanguageModel] = useState(LargeLanguageModelClass?.getClass());
    const [largeLanguageModels, setLargeLanguageModels] = useState([LargeLanguageModelClass?.getClass()]);
    const [processValues, setProcessValues] = useState({
        id: '',
        description: '',
        method: '',
        dtId: dtLargeLanguageModelsId,
        dtRowId: 0,
        type: 0,
        subMethod: ''
    });
    const [showModal, setShowModal] = useState(false);
    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    const methodNames = { changeEnabled: 'changeEnabled' };
    const btnEnabledDisabledRef = useRef(null);
    const btnEnaDeleteRef = useRef(null);
    //#endregion variables

    //#region methods (largeLanguageModels)
    const getLargeLanguageModelAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = ''
    }) => {
        const currentMethod = 'getLargeLanguageModelAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: true, add: type === 0 }));

            setProcessValues(prev => ({
                ...prev,
                id: id,
                description: description,
                dtRowId: rowIndex,
                type: type,
                subMethod: currentMethod,
            }));

            let largeLanguageModel_ = LargeLanguageModelClass?.getClass();

            switch (type) {
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.largeLanguageModel?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                preConfirmResponse = await LargeLanguageModelService.deleteById({
                                    id: id,
                                    token: auth?.account?.tokenVzLaML?.token,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod
                                });
                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                $(`#${dtLargeLanguageModelsId}`).DataTable().row(rowIndex).remove().draw(true);
                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;

                                setLargeLanguageModels(prev => prev?.filter(llm => llm?.id !== id));
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        }
                    };
                    //#endregionshow message

                    const swalresult = await Swal.fire({
                        ...swalProperties,
                    });
                    if (swalresult?.isConfirmed && swalresult?.value) {
                        response = swalresult?.value;
                    } else if (swalresult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    break;
                case 0:
                    largeLanguageModel_.userId = auth?.account?.uid;
                    setLargeLanguageModel(largeLanguageModel_);
                    break;
                case 1:
                    response = await getLargeLanguageModelById({
                        id: id,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;

                    largeLanguageModel_ = response?.result || {};
                    setLargeLanguageModel(largeLanguageModel_);
                    break;
                default:
                    return;
            }

            if (type === 0) await awaitDelay({ delayTime: timers?.oneSeconds });
            if (type !== -1) setShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getLargeLanguageModelById = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'getLargeLanguageModelById';
        let response = getResponse({ type: 0 });
        try {
            response = await LargeLanguageModelService.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const changeEnabled = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeEnabled';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            if (!id || rowIndex < 0) return;

            setProcess(prev => ({ ...prev, showLoading: true }));

            let largeLanguageModel = largeLanguageModels?.find(m => m?.id === id) || {};
            largeLanguageModel.enabled = !largeLanguageModel?.enabled;
            largeLanguageModel.languageId = languageObj?.id;

            response = await LargeLanguageModelService?.update({
                id: largeLanguageModel?.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: largeLanguageModel,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            largeLanguageModel = response?.result || {}

            setLargeLanguageModels(prev => {
                prev?.forEach(llm => {
                    if (llm?.id === id) {
                        llm = largeLanguageModel;
                    };
                });
                return prev;
            });

            setLargeLanguageModels(largeLanguageModels);
            const dtRow = setDtRow({
                data: largeLanguageModel,
                subMethod: currentMethod
            })?.result;

            $(`#${dtLargeLanguageModelsId}`).DataTable().row(rowIndex).data(dtRow).draw(false);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion methods (largeLanguageModels)

    //#region methods (others)
    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            let largeLanguageModelsDt_ = [];
            let largeLanguageModels_ = [LargeLanguageModelClass?.getClass()];
            largeLanguageModels_ = [];

            setProcess(prev => ({ ...prev, showLoading: true }));

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = clearDataTable({ dtLargeLanguageModels: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const data = {
                conditionals: [],
                ordersBy: [{ field: dbFields?.description, value: dbOrdersBy?.asc, },],
                limit: 0,
                languageId: languageObj?.id,
            };

            response = await LargeLanguageModelService.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                data: data,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            largeLanguageModels_ = !isUndNullNew({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : largeLanguageModels_;

            if (!isUndNullNew({ data: largeLanguageModels_, subMethod: currentMethod, })?.result && largeLanguageModels_?.length > 0) {
                largeLanguageModels_?.forEach((detail) => (
                    largeLanguageModelsDt_.push(
                        setDtRow({
                            data: detail,
                            subMethod: currentMethod
                        })?.result
                    )
                ))
            }

            setLargeLanguageModels(largeLanguageModels_);
            $(`#${dtLargeLanguageModelsId}`).DataTable().rows.add(largeLanguageModelsDt_).draw(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDtRow = ({
        data = LargeLanguageModelClass?.getClass(),
        subMethod = '',
    }) => {
        const currentMethod = 'setDtRow';
        let response = getResponse({ type: 0 });
        try {
            const attributes_ = {
                method: methodNames?.changeEnabled,
                id: data?.id,
                description: data?.description
            };
            const value_ = data?.enabled ?
                `<i class='${icons?.fasFa?.toggleOn}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>` :
                `<i class='${icons?.fasFa?.toggleOff}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>`;
            response.result = [
                data?.code,
                data?.description,
                setDateTimeFormatGlobal({
                    date: data?.created,
                    type: dateTimeFormat?.date,
                    format: dateTimeFormat?.time,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod
                })?.result,
                setBadgeStatusGenericNew({
                    type: data?.enabled ? 0 : 5,
                    value: value_,
                    title: data?.enabled ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id],
                    attribues: attributes_,
                    pointer: true,
                }),
                getProcessButtons({
                    id: data?.id,
                    description: data?.description,
                    detailsShow: false,
                    detailsLabel: labels?.data?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result
            ];
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtLargeLanguageModelsId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'asc']],
                columns: [
                    { title: labels?.code?.[languageObj?.id], width: '5%', orderable: true, },
                    { title: labels?.description?.[languageObj?.id], width: '65%', orderable: true, },
                    { title: labels?.created?.[languageObj?.id], width: '15%', orderable: true, },
                    { title: labels?.status?.[languageObj?.id], width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtLargeLanguageModelsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const clearDataTable = ({
        dtLargeLanguageModels = false,
        subMethod = '',
    }) => {
        const currentMethod = 'clearDataTable';
        let response = getResponse({ type: 0 });
        try {
            if (dtLargeLanguageModels) $(`#${dtLargeLanguageModelsId}`).DataTable().rows().remove().draw(true);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            let id = '';
            let rowIndex = 0;
            let methodName = '';
            let description = '';

            $(`#${dtLargeLanguageModelsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndexNew({ dtId: dtLargeLanguageModelsId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullEmpNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getLargeLanguageModelAddEditDelete({ e, id: id, description: description, rowIndex: rowIndex, type: 1, subMethod: currentMethod });
                            break;
                        case 'delete':
                            // getLargeLanguageModelAddEditDelete({ e, id: id, description: description, rowIndex: rowIndex, type: -1, subMethod: currentMethod });
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: -1, subMethod: currentMethod }));
                            btnEnaDeleteRef?.current?.click();
                            break;
                        case methodNames?.changeEnabled:
                            // getLargeLanguageModelAddEditDelete({ e, id: id, description: description, rowIndex: rowIndex, type: 2, subMethod: currentMethod });
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: 2, subMethod: currentMethod }));
                            btnEnabledDisabledRef?.current?.click();
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='settings' process='largeLanguageModels' processLevel1='list' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.largeLanguageModels?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.largeLanguageModels?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className={settings?.html?.cards?.default}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.largeLanguageModels?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.largeLanguageModels} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.largeLanguageModels?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading}
                                                data-title={labels?.add?.[languageObj?.id]}
                                                onClick={(e) => getLargeLanguageModelAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, type: 0, subMethod: 'btnAiAdd' })}>
                                                {!process?.add ? (
                                                    <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i>
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )}  {labels?.add?.[languageObj?.id]}
                                            </button>
                                            <button ref={btnEnabledDisabledRef}
                                                className='btn btn-general border border-warning shadow-sm font-weight-bold px-4 text-secondary'
                                                hidden={true}
                                                data-title={labels?.edit?.[languageObj?.id]}
                                                disabled={process?.showLoading}
                                                onClick={(e) => changeEnabled({
                                                    e: e,
                                                    id: processValues?.id,
                                                    description: processValues?.description,
                                                    rowIndex: processValues?.dtRowId,
                                                    type: processValues?.type,
                                                    subMethod: 'btnEnabledDisabledRef'
                                                })}
                                                type='button'>
                                                <i className={`${icons?.fasFa?.edit} mr-2`} />
                                                {labels?.edit?.[languageObj?.id]}
                                            </button>
                                            <button ref={btnEnaDeleteRef}
                                                className='btn btn-general border border-danger shadow-sm font-weight-bold px-4 text-secondary'
                                                hidden={true}
                                                data-title={labels?.delete?.[languageObj?.id]}
                                                disabled={process?.showLoading}
                                                onClick={(e) => getLargeLanguageModelAddEditDelete({
                                                    e: e,
                                                    id: processValues?.id,
                                                    description: processValues?.description,
                                                    rowIndex: processValues?.dtRowId,
                                                    type: processValues?.type,
                                                    subMethod: 'btnEnabledDisabledRef'
                                                })}
                                                type='button'>
                                                <i className={`${icons?.fasFa?.trashAlt} mr-2`} />
                                                {labels?.delete?.[languageObj?.id]}
                                            </button>
                                        </div>
                                        <TableIndex tableId={dtLargeLanguageModelsId} languageObj={languageObj} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <LargeLanguageModelAddEditDetails $={$}
                            auth={auth}
                            processValues={processValues}
                            setProcessValues={setProcessValues}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            largeLanguageModel={largeLanguageModel}
                            setLargeLanguageModel={setLargeLanguageModel}
                            largeLanguageModels={largeLanguageModels}
                            setLargeLanguageModels={setLargeLanguageModels}
                            setDtRow={setDtRow}
                            dateTimeFormat={dateTimeFormat} />
                    )}

                </section>
                {/* /.content */}
            </div>
        </div>
    )
}